import React, { useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import { GlobalContext } from '../context/GlobalContext';
import { Container, Button, Row, Col } from 'react-bootstrap';
import ScrollAnimation from './ScrollAnimation';

import '../style/main.less';

function HomePage() {
    const global = useContext(GlobalContext);
    const navigate = useNavigate();

    const getStarted = () => {
        navigate('/login');
    };

    return (
        <div className="homepage d-flex flex-column min-vh-100">
            <Header />

            {/* Hero Section */}
            <section className="hero-section">
                <Container>
                    <Row className="min-vh-75 align-items-center">
                        <Col lg={8} className="mx-auto text-center">
                            <ScrollAnimation>
                                <h1 className="hero-title mb-4">Press Forward Mail</h1>
                                <p className="hero-subtitle mb-5">
                                    Sharing memories one email at a time
                                </p>
                                <Button
                                    size="lg"
                                    className="cta-button px-5 py-3"
                                    onClick={getStarted}
                                >
                                    Get Started Today
                                </Button>
                            </ScrollAnimation>
                        </Col>
                    </Row>
                </Container>
            </section>

            {/* How It Works Section */}
            <section className="how-it-works-section py-5">
                <Container>
                    <ScrollAnimation>
                        <Row>
                            <Col lg={8} className="mx-auto text-center">
                                <h2 className="section-title mb-5">How It Works</h2>
                                <Row className="g-4">
                                    <Col md={4}>
                                        <div className="step-card">
                                            <div className="step-number">1</div>
                                            <h4>Enter Details</h4>
                                            <p>Add your missionary's information to get started</p>
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className="step-card">
                                            <div className="step-number">2</div>
                                            <h4>Share & Subscribe</h4>
                                            <p>
                                                Get a QR code and link to share with family and
                                                friends.
                                            </p>
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className="step-card">
                                            <div className="step-number">3</div>
                                            <h4>Stay Connected</h4>
                                            <p>
                                                We forward weekly emails to everyone on your list!
                                            </p>
                                        </div>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </ScrollAnimation>
                </Container>
            </section>
            <Footer />
        </div>
    );
}
export default HomePage;
